module.exports = __webpack_public_path__ + "static/media/javascript.e1e07bdd.svg";